const React = require('react');
const Caption = require('../../../../../dumb/Caption/B');

const SummaryStats = require('./components/SummaryStats');
const Chart = require('./components/Chart');
const ChartTabs = require('./components/ChartTabs');

module.exports = ({timePeriodEmitter}) => {
  return (
    <div className="ref-chart">
      <div className="layoutRow jcSB aiC">
        <div className="layoutRow aiFE">
          <Caption className="mb-4">
            Payout Summary
          </Caption>
          <div className="ml30">
            <span className="h24 dF aiC f16 fw7">
              $ 45,729,12
            </span>
          </div>
          <div className="ml30">
            <SummaryStats percent={-7} />
          </div>
        </div>
        <div>
          {/*
            Whole chart legend logic and styles has been written in <Chart /> component.
            Look for the d3 initialization in the component for logic/
            As for the styles - they are written at ./components/Chart/styles/index.scss
          */}
          <div className="ref-chart__legend" />
        </div>
      </div>
      <div className="ref-chart__graph-wrapper mt62">
        <Chart />
      </div>
      <div>
        <ChartTabs timePeriodEmitter={timePeriodEmitter} />
      </div>
    </div>
  );
};
